import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { defaultValues } from './invoice-batch-create-model';

import { invoiceBatchCreateFormSchema } from '../schemas/invoice-batch/invoice-batch-create-form-schema';

export function useInvoiceBatchCreateFormDefinition() {
  return useForm({
    resolver: zodResolver(invoiceBatchCreateFormSchema),
    defaultValues,
    shouldFocusError: true,
  });
}
